import { FC } from 'react';

import { useDisplayTotal } from 'components/table/components/paginator/hooks';
import { TotalProps } from 'types/components/table/components/paginator';

const Total: FC<TotalProps> = (props) => {
  const totalDisplay = useDisplayTotal(props);

  return (
    <div className="ms-auto paginator-page-of">
      <div>{totalDisplay}</div>
    </div>
  );
};

export default Total;
